const adminBackofficeDictPT = {
  adverts: "Anúncios",
  users: "Usuários",
  orders: "Pedidos",
  paidSubscriptions: "Inscrições Pagas",
  paymentMethod: "Método de pagamento",
  initialSub: "Inscrição Inicial",
  annualRenewal: "Renovação Anual",
  test: "teste",
  adminDashboard: "Painel Administrativo",
  withdrawRequests: "Solicitações de saque",
  excWithdrawRequests: "Saques Extracoin",
  markExcWithdrawCompleted: "Marcar como concluído",
  processThisExcWithdrawRequest: "Marcar esta solicitação como concluída?",
  excWithdrawProcessedSuccessfully: "Solicitação de saque Extracoin processada com sucesso!",
  searchByUsernameEmailAddress: "Pesquisar por username, e-mail ou endereço",
  requestDate: "Data da solicitação",
  processDate: "Data do processamento",
  processing: "Processando",
  amountToDeposit: "Valor para depositar",
  amountRequested: "Valor solicitado",
  processRequest: "Processar solicitação",
  process: "Processar",
  processedBy: "Processado por",
  withdrawProcessedSuccessfully: "Solicitação de saque processada com sucesso!",
  blockOrUnblockUser: "Bloquear/Desbloquear usuário",
  block: "Bloquear",
  unblock: "Desbloquear",
  user: "Usuário",
  processThisRequest: "Processar essa solicitação?",
  userBlockedSuccessfully: "Usuário bloqueado com sucesso.",
  userUnblockedSuccessfully: "Usuário desbloqueado com sucesso!",
  areYouSureBlockUser: "Tem certeza de que deseja bloquear este usuário?",
  areYouSureUnblockUser: "Tem certeza de que deseja desbloquear este usuário?",
  blocked: "Bloqueado",
  yes: "Sim",
  no: "Não",
  category: "Categorias",
  searchCategory: "Buscar Categoria",
  categoriesRegistered: "Categorias Cadastradas",
  titleCategory: "Título",
  image: "Imagem",
  descriptionPT: "Descrição português",
  descriptionIT: "Descrição italiano",
  descriptionES: "Descrição espanhol",
  descriptionEN: "Descrição inglês",
  registerNewCategory: "Cadastrar novas categoria",
  addNewCategory: "Adicionar Nova Categoria",
  newCategory: "Novo",
  categoryInfo: "Informações da categoria",
  categoryFields: "Preencha os campos com as informações da categoria.",
  categoryImage: "Imagem da categoria",
  dragImg: "Arraste sua imagem aqui",
  registerCategory: "Cadastrar",
  descriptionBrand: "Descrição marca",
  brandsRegistered: "Marcas Registradas",
  brands: "Marcas",
  addNewBrand: "Adicionar nova marca",
  brandInfo: "Informações da marca",
  brandFields: "Preencha o campo com as informações da marca.",
  registerBrand: "Registrar",
  newBrand: "Novo",
  typesCategoriesRegistered: "Tipos Categorias Registradas",
  descriptionType: "Descrição",
  descriptionTypeEN: "Descrição inglês",
  descriptionTypeES: "Descrição espanhol",
  descriptionTypeIT: "Descrição italiano",
  descriptionTypePT: "Descrição português",
  types: "Tipos",
  addNewType: "Adicionar novos tipos",
  typeInfo: "Informações do tipo",
  typeFields: "Preencha os campos com as informações do tipo.",
  newType: "Novo",
  registerType: "Registrar",
  subcategory: "Subcategorias",
  newsubcategory: "Novo",
  subcategoriesRegistered: "Subcategorias Registradas",
  descriptionSubcategoryEN: "Descrição inglês",
  descriptionSubcategoryIT: "Descrição italiano",
  descriptionSubcategoryPT: "Descrição português",
  descriptionSubcategoryES: "Descrição espanhol",
  service: "serviço",
  addNewSubcategory: "Adicionar Nova Subcategoria",
  subcategoryInfo: "Informações da subcategoria",
  subcategoryFields: "Preencha os campos com as informações da subcategoria.",
  subcategoryImage: "Imagem da subcategoria",
  registerSubcategory: "Cadastrar",
  chooseSubcategory: "Escolha pelo menos uma subcategoria",
  address: "Endereço",
  userType: "Tipo de usuário",
  chooseUser: "escolha um usuário",
  chooseAddress: "Escolha um endereço",
  UserAddressOnSendCloud: "O Endereço do usuário foi cadastrado no sendcloud?",
  searchUser: "Pesquisar usuário.",
  userInfo: "Informações do usuário",
  adminBackofficeName: "Nome",
  hasNoAttribute: "Não possui",
  adminBackofficeUserType: "Tipo de usuário",
  adminBackofficeCountry: "País",
  adminBackofficeAddress: "Endereço",
  adminBackofficeCity: "Cidade",
  adminBackofficeState: "Estado",
  adminBackofficeDistrict: "Bairro",
  adminBackofficePostalCode: "CEP",
  adminBackofficeNumber: "Número",
  adminBackofficeComplement: "Complemento",
  adminBackofficeDateCreation: "Data de criação",
  adminBackofficePhoneNumber: "Telefone",
  adminBackofficeOriginRegister: "Origem do cadastro",
  searchByEmail: "Buscar por email",
  searchByFirstname: "Buscar por  nome",
  searchByPhonenumber: "Buscar por  número de telefone",
  searchByReferralName: "Buscar por referidor",
  searchByBrand: "Buscar por marca",
  usersOfSystem: "Usuários do sistema",
  productsNotPublished: "Produtos não publicados",
  archivedProducts: "Produtos arquivados",
  productsPublished: "Produtos publicados",
  salesRevenue: "Volume de Transações",
  feeRevenue: "Receita de taxas",
  registeredStores: "Lojas registradas",
  completedOrders: "Pedidos finalizados",
  revenueFromUserRegistration: "Receita com cadastro de usuários",
  productsOfSystem: "Produtos do sistema",
  filters: "Filtros",
  search: "Pesquisar",
  searchByNameSurnameUserAccountBank: "Pesquisar por nome, sobrenome, usuário, conta bancária",
  ordersPlacedWithBangood: "Pedidos realizados com Bangood",
  actions: "Ações",
  processOrderSuccessfully: "Pedido processado com sucesso!",
  metaAdsConfig: "Configurar Anúncios da Meta",
  integrationConfig: "Configurações da integração",
  editIntegrationConfig: "Editar configuração",
  accessToken: "Token de acesso",
  pixelNumberId: "Número de ID do Pixel",
  savePixelConfig: "Salvar configuração",
  integrations: "Integrações",
  pixelConfigSaved: "Configuração salva!",
  pixelConfigSavedDetail: "Suas configurações de anúncios da Meta foram salvas com sucesso.",
  pixelConfigError: "Erro inesperado",
  pixelConfigErrorDetail: "Ocorreu um erro ao tentar salvar as suas configurações.",
  fillInAllFields: "Preencha todos os campos!",
  googleTagManagerConfiguration: "Configurar Google Tag Manager",
  gtmCodeSaved: "Código GTM salvo",
  gtmCode: "Código GTM",
  gtmEdit: "Editar Código do GTM",
  gtmRegister: "Registrar Código do GTM",
  confirmed: "Pagamento Confirmado",
  paymentConfirmed:
    "Você confirmou com sucesso o recebimento do pagamento por transferência bancária.",
  pendingOrders: "Pedidos Pendentes",
  transferConfirm: "Confirmar Transferência",
  buyer: "Comprador",
  totalAmount: "Valor Total",
  date: "Data",
  noPendingOrders: "Sem pedidos por transferência bancária em pendência.",
  youHavePendingOrders: "Você tem vendas pendentes",
  youHavePendingUsers: "Você tem usuários pendentes",
  seeYourPendingOrders: "Veja suas vendas por transferência bancária que estão com pendências.",
  seeYourPendingUsersBankTransfer:
    "Veja seus usuários que estão com transferências bancárias pendêntes.",
  pendings: "Vendas Pendentes",
  usersPendings: "Usuários Pendentes",
  bankTransfers: "Transferências Bancárias",
  receipt: "Comprovante",
  searchForPlan: "Pesquisar por plano",
  authorize: "Autorizar",
  confirmTransfer: "Confirmar transferência?",
  pendingIssues: "Pendências",
  quantityOfWithdrawsCompleted: "Quantidade de saques concluído",
  totalAmountWithdrawsCompleted: "Valor total dos saques concluídos",
  totalOfUsersPublishedAds: "Total de usuários que publicaram anúncios",
  totalofCommissionsPaid: "Total de comissões pagas",
  bestOffers: "MELHORES OFERTAS",
  youHaveUnprocessedOrders: "Você tem pedidos Bangood não processados",
  pendingBangoodOrders: "Veja seus pedidos Bangood não processados.",
  bannersOfShop: "Banners da loja",
  dragJustOneImage: "Arraste apenas uma imagem",
  imageDesktopEnglish: "Imagem Desktop inglês",
  imageDesktopItalian: "Imagem Desktop italiano",
  imageDesktopPortuguese: "Imagem Desktop português",
  imageDesktopSpanish: "Imagem Desktop espanhol",
  imageMobileEnglish: "Imagem Mobile inglês",
  imageMobileItalian: "Imagem Mobile italiano",
  imageMobilePortuguese: "Imagem Mobile português",
  imageMobileSpanish: "Imagem Mobile espanhol",
  language: "Idioma",
  english: "Inglês",
  portuguese: "Português",
  italian: "Italiano",
  spanish: "Espanhol",
  dontHaveImage: "Não há imagem",
  principalBanner: "Banner Principal",
  file: "Arquivo",
  showBanner: "Mostrar banner",
  noImageSelected: "Nenhuma imagem selecionada",
  keepImageInRequiredAspectRatio: "Matenha a imagem na proporção exigida",
  doYouWantToRepeatThisImage: "Deseja repetir essa imagem para outro banner?",
  documents: "Documentos",
  document: "Documento",
  seeDoc: "Ver documento",
  downloadDoc: "Baixar documento",
  urlToRedirect: "Url para redirecionar usuário ao clicar no banner ",
  addNewBanner: "Adicionar novo banner",
  removeBanner: "Remover banner",
  settingsSaved: "Configurações salvas",
  generalSettings: "Configurações gerais",
  sliderChangeTime: "Tempo de troca do slider",
  seconds: "Segundos",
  youHavePendingWithdraws: "Você tem saques pendentes",
  seeYourPendingWithdraws: "Veja seus saques pendentes.",
  youHavePendingPhysicalStores: "Você tem lojas físicas aguardando verificação",
  seeYourPendingPhysicalStores: "Revise as lojas aguardando aprovação.",
  withdrawPendings: "Saques pendentes",
  subnets: "Sub-redes",
  ownerName: "Nome do proprietário",
  pleaseEnterName: "Por favor, insira um nome",
  pleaseEnterDescription: "Por favor, insira uma descrição",
  pleaseSelectManager: "Por favor, selecione um manager",
  whitelabelSubnetCreatedSuccessfully: "Sub-rede Whitelabel criada com sucesso",
  errorCreatingWhitelabelSubnet: "Erro ao criar sub-rede Whitelabel",
  personalizeSubnetTheme: "Personalizar tema da sub-rede",
  personalizeTeam: "Personalizar tema",
  reports: "Relatórios de contabilidade",
  paidOrdersReport: "Relatório de Pedidos Pagos",
  completedWithdrawalsReport: "Relatório de Saques Concluídos",
  paidSubscriptionsReport: "Relatório de Assinaturas Pagas",
  downloadPdf: "Baixar PDF",
  noData: "Nenhum dado disponível",
  pdfDownloadedSuccessfully: "PDF baixado com sucesso",
  errorDownloadingPdf: "Erro ao baixar PDF",
  errorFetchingData: "Erro ao buscar dados",
  success: "Sucesso",
  taxId: "CPF/CNPJ",
  planType: "Tipo de Plano",
  startDate: "Data de Início",
  endDate: "Data de Fim",
  exportData: "Exportar dados",
  paidOrdersHeaderNumber: "N°",
  paidOrdersHeaderBuyer: "Comprador",
  paidOrdersHeaderSeller: "Vendedor",
  paidOrdersHeaderDate: "Data",
  paidOrdersHeaderOrderAmount: "Vl. Pedido",
  paidOrdersHeaderPaidAmount: "Vl. Pago",
  paidOrdersHeaderCommission: "Comissão",
  paidOrdersHeaderPayPal: "PayPal",
  paidOrdersHeaderWallet: "Carteira",
  paidOrdersHeaderExtraCredit: "ExtraCredit",
  paidOrdersHeaderBankTransfer: "Transferência",
  paidOrdersHeaderStatus: "Status",
  paidOrdersHeaderInvoiceBuyer: "Fatura Comprador",
  paidOrdersHeaderInvoiceSeller: "Fatura Vendedor",
  paidOrdersHeaderPlatformFeeBuyer: "Taxa de Plataforma Comprador (5%)",
  paidOrdersHeaderPlatformFeeSeller: "Taxa de Plataforma Vendedor (5%)",
  paidOrdersHeaderPaidToSeller: "Pago ao Vendedor",
  paidOrdersStatusOnHold: "Em espera",
  completedWithdrawalsHeaderId: "ID",
  completedWithdrawalsHeaderDestination: "Destino",
  completedWithdrawalsHeaderProcessedBy: "Processado por",
  completedWithdrawalsHeaderRequestDate: "Data da solicitação",
  completedWithdrawalsHeaderProcessDate: "Data do processamento",
  completedWithdrawalsHeaderAmountRequested: "Valor solicitado",
  completedWithdrawalsHeaderAmountToDeposit: "Valor a depositar",
  completedWithdrawalsHeaderFee: "Taxa",
  completedWithdrawalsColDestinationType: "Tipo Dest.",
  completedWithdrawalsColPayment: "Pagamento",
  completedWithdrawalsColRequestedValue: "Valor Req.",
  completedWithdrawalsColNetValue: "Val. Líquido",
  searchBySurname: "Pesquisar por sobrenome",
  searchByDocument: "Pesquisar por documento",
  searchByAddress: "Pesquisar por endereço",
  searchByPaymentMethod: "Pesquisar por método de pagamento",
  orderNumber: "Número do pedido",
  logoutAccount: "Sair da conta",
  logoOrFavicon: "Você pode enviar apenas a logo, apenas o favicon, ou ambos",
  footerFieldsInfo: "Os campos abaixo vão aparecer no footer do dashboard do whitelabel.",
  approveStore: "Aprovar loja",
  rejectStore: "Rejeitar loja",
  confirmApproveStore: "Tem certeza que deseja aprovar esta loja?",
  enterRejectionReason: "Informe o motivo da rejeição",
  storeApprovedSuccessfully: "Loja aprovada com sucesso!",
  storeRejectedSuccessfully: "Loja rejeitada com sucesso!",
  physicalStores: "Lojas Físicas",
  physicalStoresRegistered: "Lojas Físicas Aprovadas",
  physicalStoresApproved: "Lojas Aprovadas",
  physicalStoresPending: "Verificações Pendentes",
  searchByStoreName: "Buscar por nome da loja",
  physicalStoreName: "Nome da loja",
  storeOwner: "Proprietário",
  viewDetails: "Ver detalhes",
  storeDetails: "Detalhes da loja",
  conventionPdf: "PDF da Convenção",
  legalRepresentative: "Representante legal",
  piva: "PIVA (Partita IVA)",
  signatureIp: "IP da assinatura",
  signedAt: "Assinado em",
  openPhoto: "Abrir foto",
  openConvention: "Abrir PDF da convenção",
  establishmentPhoto: "Foto do estabelecimento",
  verificationStatus: "Status",
  submittedAt: "Enviado em",
  statusPending: "Pendente",
  statusApproved: "Aprovada",
  statusRejected: "Rejeitada",
  storeCompanyName: "Razão social",
  commercialName: "Nome comercial",
  merchantCategory: "Categoria do estabelecimento",
  storePhone: "Telefone da loja",
  invoiceStatus: "Faturamento",
  invoiceStatusSent: "Fatura emitida",
  invoiceStatusError: "Erro ao emitir fatura",
  invoiceStatusPending: "Fatura pendente",
  invoiceStatusNotApplicable: "Não aplicável",
  automaticInvoicing: "Faturação Automática",
  automaticInvoicingDescription: "Habilita ou desabilita a emissão automática de fatura eletrônica para as assinaturas pagas e para os pedidos.",
  invoicingEnabledSuccessfully: "Faturação automática habilitada com sucesso",
  invoicingDisabledSuccessfully: "Faturação automática desabilitada com sucesso",
  errorTogglingInvoicing: "Erro ao alterar a faturação automática",
  errorFetchingInvoicingStatus: "Erro ao buscar o status da faturação automática",
};

export default adminBackofficeDictPT;
